import { render, staticRenderFns } from "./IconRadio.vue?vue&type=template&id=013afe4c&scoped=true"
import script from "./IconRadio.vue?vue&type=script&lang=js"
export * from "./IconRadio.vue?vue&type=script&lang=js"
import style0 from "./IconRadio.vue?vue&type=style&index=0&id=013afe4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013afe4c",
  null
  
)

export default component.exports